import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CommonWebinarSessionLink from 'common/components/entities/WebinarSessionLink/WebinarSessionLinkNew'
import WebinarSessionLinkInterface from 'common/types/entities/WebinarSessionLinkInterface'
import React from 'react'
import { EntityProps } from '../../../types'

function WebinarSessionLink({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<WebinarSessionLinkInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonWebinarSessionLink
        htmlAttrId={entity.htmlAttrId}
        text={entity.text}
        redirectUrl="https://yoursubdomain.systeme.io/webinar/name/show/client-hash"
        color={entity.color}
        mobileColor={entity.mobileColor}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
        textAlign={entity.textAlign}
        mobileTextAlign={entity.mobileTextAlign}
      />
    </BaseEntityNew>
  )
}

export default WebinarSessionLink
